import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import CardMedia from "@mui/material/CardMedia";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableRowsIcon from "@mui/icons-material/TableRows";
import GridViewIcon from "@mui/icons-material/GridView";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PageviewIcon from "@mui/icons-material/Pageview";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";

import { budgetOptions, MANUFACTURER_SERVICES } from "utils/data";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker, Tag } from "antd";

import UTreeSelect from "components/UpStyled/UTreeSelect";

import { filterParser, sortParser } from "utils/helper";
import { stylesSortOptions, seasonOptions } from "utils/data";
import { handleUploadFiles, getStyleImages, getTechPackImages } from "utils/imageHelper";

import StyleCard2 from "components/UpStyled/StyleCard2";
import StyleDetail from "pages/de/styles/detail";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";

import DeleteStyleFromCollectionModal from "pages/de/collection/components/DeleteStyleFromCollectionModal";
import EmptyStyleCard from "pages/de/styles/components/EmptyStyleCard";
import EmptyStyleRecord from "pages/de/styles/components/EmptyStyleRecord";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Avatar from "@mui/material/Avatar";

import Error404 from "pages/error/404";
const avatarSize = 26;

const AdminStyles = ({ sharedView = false }) => {
  const [view, setView] = useState("table"); //grid,table
  const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [searchStr, setSearchStr] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [colorOptions, setColorOptions] = useState([]);

  let location = useLocation();
  const navigate = useNavigate();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const styleId = urlObj?.query?.id;

  const user = useContext(AccountContext);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    reset({ sort_by: stylesSortOptions[0] });
    retrievePalette();
  }, []);

  useEffect(() => {
    if (user.id) {
      const offset = pageSize * (page - 1);
      const limit = pageSize;
      let filter = {};
      retrieveStyles(offset, limit, "", filter);
    }
  }, [user.id, styleId, url]);

  const retrieveStyles = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
    const payload = { offset, limit };
    if (q) {
      payload["q"] = q;
    }
    let myFilter = {};

    if (Object.keys(filter).length > 0) {
      myFilter = { ...myFilter, ...filter };
    }

    //get sorting options from form values
    const sortOpt = getValues("sort_by");
    let sortStr = "";

    if (sortOpt && sortOpt.value) {
      sortStr = sortParser(sortOpt.value);
    }

    myFilter = {
      ...myFilter,
    };

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
      setFilterObj(myFilter);
    }
    if (sortStr) {
      payload["sort"] = [sortStr];
    }
    try {
      //const { data } = await api.project.list({ owner_id: user.id });

      const { data } = await api.products.adminSearchStyles(payload);

      setData(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleApply = () => {
    const data = getValues();
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    setSearchStr(data["keywords"]);
    let myFilter = {};

    //collection filter
    if (data["collection"] && data["collection"].value) {
      myFilter["collection_id"] = data["collection"].value;
    }
    //category filter
    if (data["category"]) {
      myFilter["categories"] = data["category"];
    }
    //season filter
    if (data["season"] && data["season"]?.value) {
      myFilter["style_season"] = data["season"].value;
    }
    //year filter
    if (data["year"]) {
      let formatYearValue = moment(data["year"]).format("YYYY");
      myFilter["style_year"] = formatYearValue;
    }

    retrieveStyles(offset, limit, data["keywords"], myFilter);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;
    retrieveStyles(offset, limit, searchStr, filterObj);
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    retrieveStyles(offset, limit, searchStr, filterObj);
  };

  const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
  const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }
  let entriesStart = pageSize * (page - 1) + 1;
  const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;
  if (entriesStart > entriesEnd) {
    entriesStart = entriesEnd;
  }

  const handleViewChange = (e, value) => {
    if (value !== null) {
      setView(value);
    }
  };

  const retrievePalette = async () => {
    let payload = {
      order: "-updated_at",
    };

    try {
      const { data } = await api.palette.list(payload);

      const colors = data["colors"] ? data["colors"] : [];
      const options = colors.map((x) => ({ label: x.name, value: x.id, hex: x.hex }));
      setColorOptions(options);
    } catch (err) {
      console.log(err);
    }
  };

  const getStyleTableRow = (item) => {
    const styleMeta = item?.style || {};
    const storeInfo = item?.store || {};

    let category = item?.type || "N/A";
    let path = [];
    if (typeof category == "object") {
      category = category?.value;
    } else {
      const categoryNode = findNodeByID(tree, category);

      category = categoryNode?.label || category;
    }

    const colorIds = styleMeta?.color_way?.map((x) => x.value) || [];
    const color_way = colorOptions.filter((x) => colorIds.includes(x.value));

    let styleImages = getStyleImages(item, false);
    let techPackImages = getTechPackImages(item, false);

    return {
      key: item.id,
      image: styleImages.length > 0 ? styleImages[0] : null,
      techPack: techPackImages.length > 0 ? techPackImages[0] : null,
      name: item.title,
      collection: item.collection?.title,
      style_number: styleMeta?.style_number,
      color_way: color_way,
      sizeRange: styleMeta?.sizeRange,
      category: category,
      created_at: item.created_at,
      updated_at: item.updated_at,
      season: styleMeta?.season,
      year: styleMeta?.year,
      brand: styleMeta?.brand,
      owner: storeInfo,
      ownerName: storeInfo?.name,
      action: item,
    };
  };

  const columns = [
    {
      Header: "Image",
      accessor: "image",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link to={`/workspace/styles-master?id=${row?.original?.key}`}>
            <ImageCardWrapper data={value} mode={"normal"} height={90} width={90} iconMode />
          </Link>
        );
      },
    },

    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ maxWidth: 300 }}>{value}</div>;
      },
    },
    {
      Header: "Style No.",
      accessor: "style_number",
      isSorted: false,
      canSort: false,
    },
    {
      Header: "Tech Pack",
      accessor: "techPack",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link
            to={`/workspace/styles-master?id=${row?.original?.key}&stage=tech-pack`}
            onClick={(e) => e.stopPropagation()}
          >
            <ImageCardWrapper data={value} mode={"normal"} height={90} width={90} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Collection",
      accessor: "collection",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word" }}>{value}</div>;
      },
    },
    {
      Header: "Category",
      accessor: "category",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word" }}>{value}</div>;
      },
    },
    {
      Header: "Season",
      accessor: "season",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word" }}>{value?.label}</div>;
      },
    },
    {
      Header: "Year",
      accessor: "year",
      Cell: ({ row, value }) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{value ? moment(value).format("YYYY") : ""}</div>
        );
      },
    },
    {
      Header: "Updated Date",
      accessor: "updated_at",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY") : "";
      },
    },
    {
      Header: "Owner",
      accessor: "ownerName",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/wall/portfolio/${row.original?.owner?.id}`);
            }}
          >
            <Avatar
              src={row.original?.owner?.metadata?.avatar}
              sx={{ width: avatarSize, height: avatarSize, mr: 0.5 }}
            />
            {value}
          </SuiBox>
        );
      },
    },
    {
      Header: "More",
      accessor: "action",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => (
        <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Tooltip title="View Details">
            <SuiBox component={Link} to={`/workspace/styles-master?id=${value.id}`}>
              <ManageSearchIcon fontSize={"small"} color="dark" />
            </SuiBox>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const rows = data.hits.map((item) => getStyleTableRow(item));

  const handleRowClick = (row) => {
    navigate(`/workspace/styles-master?id=${row?.original?.key}`);
    //window.open(`/workspace/styles-master?id=${row?.original?.key}`, "_blank");
  };

  const handleClearFilter = () => {
    reset({
      season: null,
      year: null,
      collection: null,
      category: null,
      sort_by: stylesSortOptions[0],
      q: "",
    });
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    handleApply();
  };

  return (
    <SuiBox my={1}>
      <Card sx={{ p: 3 }}>
        <SuiBox component="form" pb={3} onSubmit={handleSubmit(handleApply)}>
          <SuiBox
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <SuiBox display="flex" alignItems="center" sx={{ gap: 0.5, flexWrap: "wrap" }}>
              <SuiTypography variant="button" color="dark" fontWeight="regular">
                Filter by:
              </SuiTypography>
              <div style={{ width: 100 }}>
                <Controller
                  name="year"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      picker="year"
                      placeholder="Year"
                      style={{
                        height: 40,
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #d2d6da",
                      }}
                      popupStyle={{
                        maxHeight: 400,

                        overflow: "auto",
                        zIndex: 9999,
                      }}
                    />
                  )}
                />
              </div>
              <div style={{ width: 130 }}>
                <Controller
                  name="season"
                  control={control}
                  render={({ field }) => (
                    <SuiSelect
                      {...field}
                      options={seasonOptions}
                      placeholder="Season"
                      backspaceRemovesValue
                    />
                  )}
                />
              </div>
              <div style={{ minWidth: 220 }}>
                <Controller
                  control={control}
                  name="category"
                  render={({ field: { onChange, onBlur, value, name, ref } }) => (
                    <UTreeSelect
                      tree={tree}
                      fieldNames={{ label: "label", value: "id", children: "children" }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                      allowClear={true}
                      value={value}
                      placeholder="Category"
                    />
                  )}
                />
              </div>
              <div style={{ width: 145 }}>
                <Controller
                  name="sort_by"
                  control={control}
                  render={({ field }) => (
                    <SuiSelect
                      {...field}
                      options={stylesSortOptions}
                      placeholder="Sort By"
                      backspaceRemovesValue
                    />
                  )}
                />
              </div>
              <SuiBox>
                <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
              </SuiBox>
              <div>
                <SuiButton variant="gradient" color="dark" type="submit">
                  Apply
                </SuiButton>
              </div>
              <SuiButton variant="text" color="dark" onClick={handleClearFilter}>
                Clear
              </SuiButton>
            </SuiBox>
            <SuiBox display="flex" alignItems="center" sx={{ gap: 1 }}>
              <ToggleButtonGroup value={view} exclusive onChange={handleViewChange} color="info">
                <Tooltip title="List View">
                  <ToggleButton value="table">
                    <TableRowsIcon fontSize="sm" />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title="Card View">
                  <ToggleButton value="grid">
                    <GridViewIcon fontSize="sm" />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </SuiBox>
          </SuiBox>
        </SuiBox>

        {view == "grid" ? (
          <SuiBox display="flex" justifyContent="flex-start" sx={{ flexWrap: "wrap" }}>
            {data.hits.map((u, index) => {
              return (
                <StyleCard2
                  product={u}
                  size="md"
                  detailUrl={`/workspace/styles-master?id=${u.id}`}
                />
              );
            })}
            null
          </SuiBox>
        ) : rows.length > 0 ? (
          <DataTable
            table={{ columns, rows: rows }}
            entriesPerPage={{ defaultValue: pageSize }}
            showTotalEntries={false}
            pagination={false}
            noEndBorder
            handleRowClick={handleRowClick}
            isSorted={false}
          />
        ) : null}
        <SuiBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={3}
        >
          <div className="flex items-center">
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
              </SuiTypography>
            </SuiBox>

            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiSelect
                defaultValue={{ value: pageSize, label: pageSize }}
                options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                onChange={handleChangeRowsPerPage}
                size="small"
              />

              <SuiTypography variant="caption" color="secondary">
                entries per page
              </SuiTypography>
            </SuiBox>
          </div>
          <Pagination
            variant={"outlined"}
            color={"info"}
            count={pageOptions.length}
            defaultPage={page}
            onChange={handleChangePage}
          />
        </SuiBox>
      </Card>
    </SuiBox>
  );
};

export default AdminStyles;
